import { createGlobalStyle } from "styled-components";
import { devices } from "./Breakpoints";
import Graphik400 from "../../assets/Fonts/Graphik/Graphik-400-Regular.otf";
import Graphik500 from "../../assets/Fonts/Graphik/Graphik-500-Medium.otf";
import Graphik600 from "../../assets/Fonts/Graphik/Graphik-600-Semibold.otf";
import Graphik700 from "../../assets/Fonts/Graphik/Graphik-700-Bold.otf";

// Created using mobile first Development
const GlobalStyles = createGlobalStyle`

/* Meyers Reset CSS */
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	/* font: inherit; */
	vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
select,
  textarea,
  input[type="text"],
  input[type="password"],
  input[type="datetime"],
  input[type="datetime-local"],
  input[type="date"],
  input[type="month"],
  input[type="time"],
  input[type="week"],
  input[type="number"],
  input[type="email"],
  input[type="url"],
  input[type="search"],
  input[type="tel"],
  input[type="color"] {
    font-size: 16px;
  }
/* ------------------------------------------------ */
// Adding font
@font-face {
    font-family: 'Graphik';
    src: local('Graphik'), url(${Graphik400}) format('truetype');
    font-weight: 400;
    }
@font-face {
    font-family: 'Graphik';
    src: local('Graphik'), url(${Graphik500}) format('truetype');
    font-weight: 500;
    }
@font-face {
    font-family: 'Graphik';
    src: local('Graphik'), url(${Graphik600}) format('truetype');
    font-weight: 600;
    }
@font-face {
    font-family: 'Graphik';
    src: local('Graphik'), url(${Graphik700}) format('truetype');
    font-weight: 700;
    }

/* Custom css */
* {
  box-sizing: border-box;
  font-family: 'Graphik';
  /* font-family: 'Graphik Bold'; */

  
}

html, body, #root {
    height: 100%;
    width: 100%;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: none;
    overflow: hidden;
    @media ${devices.tablet} {
        overflow: auto;
    }
}

#root {
    background: ${({ theme }) => theme.colors.grey};
    display: flex;
    flex-direction: column;
}

h1 {
    color: #131228 ;
    font-style: normal;
    font-weight: normal;
    font-size: 48px;
}
h2 {
    color: #131228;
    font-style: italic;
    font-weight: normal;
    font-size: 32px;
}
h3 {
    color: #131228;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
}
h4 {
    color: #131228;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
}
p {
    color: rgb(82,82,82);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    /* line-height: 16px; */
}

.main-content {
    display: flex;
    flex-direction: column;
    height: calc(100% - 66px);
    width: 100%;
}
button {
    font-weight: 500;
}

// Tablet view and higher
@media ${devices.tablet} {
h1 {
    font-size:52px
}
h2 {
    font-size:48px
}
h3 {
    font-size:32px
}
h4 {
    font-size:24px
}
p {
    font-size:16px
}
}

/* Tablet Landscape */

@media ${devices.tablet} {
    .main-content {
        height: calc(100vh - 80px);

  }
}

@media ${devices.tablet} and (orientation: landscape) {
  .main-content {
      flex-direction: row-reverse;
  }
}
`;

export default GlobalStyles;
